<template>
 

  <div class="vx-row">
    <div class="vs-table-text vx-col mt-2">
      <span class="mb-1">&nbsp;</span>
      <div v-if="sampleNumber"><strong>{{ this.sampleNumber }}</strong></div>
      <div v-if="locationStats"><strong>{{ this.locationName }}</strong></div>
    </div>
    <div v-for="(result) in sampleResultInfos" :key="result.element" class="vx-col mt-2 pr-2 pl-2 elementDiv"  :class=" {selectedElement: result.element == selectedMeasuredElement }">
      <div class="vs-table-text" @click="updateMeasureElement(result.element)">
        <span class="mb-1"><strong>{{$t("MeasuredElement." + result.element)}}</strong></span>
        <div>{{ $systemUnits.convertGradeRounded(result.grade,  result.element)  }}
          <feather-icon icon="AlertTriangleIcon" class="text-danger" svgClasses="h-5 w-5 mr-4 hover:text-primary"  v-if="getHasWarning(result.element) === 2"  />
          <feather-icon icon="AlertTriangleIcon" class="text-warning" svgClasses="h-5 w-5 mr-4 hover:text-primary"  v-if="getHasWarning(result.element) === 1"  /></div>
        <div v-if="locationStats">{{ getElementLocationStatsGrade(result.element) }}</div>
      </div>
    </div>
  </div>
</template>

<script>

import LocationTypeEnum from "../../LocationTypeEnum.js";

export default {
  name: 'AverageGrades',
  props: {
    sampleNumber: {
      type: String
    },
    locationStats: {
      type: Object
    },
    sampleResultInfos: {
      type: Array
    },
    selectedMeasuredElement : {
      type: Number
    },
    sampleMeasures : {
      type: Array
    }
  },
  computed : {
    locationName() {
      if (this.locationStats) {
        const typeDef = LocationTypeEnum.getSuffix(this.locationStats.locationType);
        return this.locationStats.locationCode + "-" + typeDef;
      }
      
      return "";

    }
  },
  methods: {
    getHasWarning(elementId) {
      if (this.sampleResultInfos !== null) {
        const elements = this.sampleMeasures.filter(r => r.element === elementId && (r.pctFromAverage >= 20 || r.pctFromAverage <= -20))
        if (elements !== undefined && elements.length > 0) {
          const someExcluded = elements.filter(e => e.isExcluded === true);
          if (someExcluded !== undefined && someExcluded.length > 0)
            return 1;
          else
            return 2;
        }
        else {
          return 0;
        }
      }
      else {
        return 0;
      }
    },
    updateMeasureElement(measureElement) {
      this.$emit("onUpdateMeasureElement", measureElement);
    },
    getElementLocationStatsGrade(element) {
      if (this.locationStats && this.locationStats !== null) {
        const elementStats = this.locationStats.elementsGradeStats.find(e => e.element === element);

        if (typeof elementStats !== 'undefined') {
          return this.$systemUnits.convertGradeRounded(elementStats.grade, elementStats.element);
        } 
      }

      return "N/A";
      
    }
  }
};
</script>

<style lang="scss">
  .elementDiv {
     cursor: pointer;
  }
  .selectedElement {
     background-color : #DCDCDC;
     border-style: solid;
     border-width: 1px;
     border-color: #A9A9A9;
     border-radius: 5px;
  }

</style>

